// extracted by mini-css-extract-plugin
export default {"card":"Profile_card__XpoPA"};